import { useState, useEffect } from "react"

import Box from "../../Global/Atomics/Box"
import { Button, StyledButton } from "../../Global/Atomics/Button"
import { Paragraph } from "../../Global/Atomics/Paragraph"
import CustomIcon from "../../Global/Icons/CustomIcon"

import { useA2HSContext } from "../../../contexts/A2HSContext"
import { useResponsiveContext } from "../../../contexts/ResponsiveContext"
import { useTranslationContext } from "../../../contexts/TranslationContext"
import { getStorageWithExpiry, setStorageWithExpiry } from "../../../utils/helpers/localStorage"

const PWAPrompt = () => {
    const [isVisible, setVisibleState] = useState(false);
    const { prompt, promptToInstall } = useA2HSContext();
    const [viewMode] = useResponsiveContext();
    const { resources } = useTranslationContext();

    const isMobile = viewMode === 'mobile'

    // Get PWAPrompt from local storage and verify if user has previously hidden it
    const storagePWAPrompt = getStorageWithExpiry('PWAPrompt');

    // Hide PWAPrompt by adding to localStorage (with expiry time)
    const hidePWAPrompt = () => {
        setVisibleState(false);
        setStorageWithExpiry('PWAPrompt', true, 30000) // hide for X time
    }

    useEffect(() => {
        if (prompt) {
            setVisibleState(true);
        }
    }, [prompt]);

    if (!isVisible || storagePWAPrompt) return null;

    return (
        <Box bg="green-nova-2" borderRadius="md" boxShadow="level2" p="md" mb="md">
            <Box display="flex" justifyContent="space-between" alignItems="start">

                {/* Icon + Text and CTA */}
                <Box display="flex">
                    <Box>
                        <CustomIcon icon="NovaPersonsIcon" customColor="black-1" />
                    </Box>
                    <Box display="flex" flexDirection="column" mx={isMobile ? 'md' : 'xl'}>
                        <Paragraph typography="text-xs-medium" customColor="black-1" mb="md">{resources.home.pwaPrompt.description}</Paragraph>
                        <Box>
                            <Button id="installApp" role="button" aria-label={resources.home.pwaPrompt.cta} size="s" variant="primary-black" onClick={promptToInstall}>
                                {resources.home.pwaPrompt.cta}
                            </Button>
                        </Box>
                    </Box>
                </Box>

                {/* Close */}
                <StyledButton onClick={hidePWAPrompt} aria-label="Close">
                    <CustomIcon icon={"ActionClose_sm"} customColor="black-1" />
                </StyledButton>
            </Box>
        </Box>
    )
}

export default PWAPrompt